import type { DocumentItem } from '@/js/account/entities/document/model/types';
import type { SingleImage } from '@/js/account/shared/model';

export function resolveSingleImageUrl(
  image: SingleImage | null | undefined,
): string | null {
  return image?.url ?? image?.url2x ?? null;
}

export function getDocumentCoverUrl(document: DocumentItem): string | null {
  return (
    resolveSingleImageUrl(document.coverDesktop)
    ?? resolveSingleImageUrl(document.coverMobile)
  );
}
